module.exports = __webpack_public_path__ + "img/save.9d244370.svg";